import React, { useState } from "react";
import { storeAccessCode, verifyAccessCode } from "../../lib/registration";

const ERROR_MESSAGES = {
  empty: "Zadej prosím kód.",
  invalid: "Tento kód tě do Země vzpomínek nepustí. Zkontroluj ho a zkus to znovu.",
  network: "Nepodařilo se ověřit kód, zkus to znovu.",
};

/** Asks for the early-access code. On success it remembers the code and calls `onUnlocked(code)`. */
const AccessCodeForm = ({ onUnlocked, idPrefix = "access" }) => {
  const [code, setCode] = useState("");
  // idle | checking | empty | invalid | network
  const [status, setStatus] = useState("idle");
  const inputId = `${idPrefix}-code`;
  const errorId = `${idPrefix}-code-error`;
  const errorMessage = ERROR_MESSAGES[status];

  const handleChange = (event) => {
    setCode(event.target.value);
    if (errorMessage) setStatus("idle");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) {
      setStatus("empty");
      return;
    }
    setStatus("checking");
    try {
      const isValid = await verifyAccessCode(trimmed);
      if (!isValid) {
        setStatus("invalid");
        return;
      }
      storeAccessCode(trimmed);
      onUnlocked(trimmed);
    } catch {
      setStatus("network");
    }
  };

  return (
    <form className="access-form" onSubmit={handleSubmit} noValidate>
      <div className="field">
        <label htmlFor={inputId}>Přístupový kód</label>
        <input
          id={inputId}
          type="text"
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          placeholder="např. K7QM-3XPA"
          value={code}
          onChange={handleChange}
          className={errorMessage ? "invalid" : undefined}
          aria-invalid={Boolean(errorMessage)}
          aria-describedby={errorMessage ? errorId : undefined}
        />
        {errorMessage && (
          <span id={errorId} className="err" role="alert">
            {errorMessage}
          </span>
        )}
      </div>
      <button type="submit" className="btn btn-marigold" disabled={status === "checking"}>
        {status === "checking" ? "Ověřuji…" : "Vstoupit"}
      </button>
    </form>
  );
};

export default AccessCodeForm;
